import React, { useEffect, useState } from 'react';
import moment, { Moment } from 'moment';
import Icon from 'component/Icon';
import classnames from 'classnames';
import { createWeekDate } from './utils';

import styles from './Calendar.module.scss';

const HeaderList: string[] = ['日', '一', '二', '三', '四', '五', '六'];

interface IProps {
  date: Moment;
  selectDate: number;
  today: Moment;
  taskList?: number[];
  noticeList?: number[];
  onChange?: (date: Moment, dateList: Moment[]) => void;
  onSelect?: (date: Moment) => void;
}

interface DateItem {
  _id: number;
  _date: Moment;
  day: number;
  no: number;
  disabled: boolean;
}

const getDateList = (date: Moment) => {
  return createWeekDate(date).map((d) => createDateItem(d, date));
};

const createDateItem = (date: Moment, originDate: Moment): DateItem => {
  return {
    _id: getDateId(date),
    _date: date,
    day: date.day(),
    no: date.date(),
    disabled: date.month() !== originDate.month()
  };
};

const getDateId = (date: Moment) => {
  return moment(date.format('YYYY-MM-DD')).valueOf();
};

const CalendarBar: React.FC<IProps> = (props) => {
  const { date, selectDate, today, noticeList = [], taskList = [], onChange, onSelect } = props;

  const [dateList, setDateList] = useState<DateItem[]>(getDateList(today));
  const [currentDate, setCurrentDate] = useState<Moment>(today);
  const todayId = getDateId(today);
  const selectDateId = selectDate;

  const toggleDate = (val: number) => {
    const date = currentDate[val > 0 ? 'add' : 'subtract'](7, 'd');
    setCurrentDate(date);
    const dateList = getDateList(date);
    setDateList(dateList);

    // 优化月头/月末切换时的衔接，保持头尾与当前月一致
    const changeDate = dateList[val > 0 ? 0 : dateList.length - 1]._date;
    onChange &&
      onChange(
        changeDate,
        dateList.map((d) => d._date)
      );
  };

  const handleSelectDate = (data: DateItem) => {
    onSelect && onSelect(data._date);
  };

  useEffect(() => {
    setCurrentDate(date);
    const dateList = getDateList(date);
    setDateList(dateList);
  }, [date]);

  useEffect(() => {
    // 初始化后执行一次
    // onChange &&
    //   onChange(
    //     currentDate,
    //     dateList.map((d) => d._date)
    //   );
  }, []);

  const itemClassName = (data: DateItem) => {
    const dateTime = data._date.valueOf();
    return classnames(styles.item, {
      [styles.today]: todayId === data._id,
      [styles.selected]: selectDateId === data._id,
      [styles.disabled]: data.disabled,
      [styles.isNotice]: noticeList.indexOf(dateTime) !== -1,
      [styles.isTask]: taskList.indexOf(dateTime) !== -1
    });
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.arrowLeft}>
        <Icon onClick={() => toggleDate(-1)} type="icontime_arrow_left_ic1x" color="#595959" />
      </div>

      <div className={styles.list}>
        {HeaderList.map((d, index) => (
          <div className={itemClassName(dateList[index])} key={d}>
            <div className={styles.header}>周{d}</div>
            <div className={styles.content} onClick={() => handleSelectDate(dateList[index])}>
              <span className={styles.text}>{dateList[index].no}</span>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.arrowRight}>
        <Icon onClick={() => toggleDate(1)} type="icontime_arrow_right_ic1x" color="#595959" />
      </div>
    </div>
  );
};

export default CalendarBar;
